/**
 * Two Supabase instances:
 *
 * 1. Cloud (REACT_APP_SUPABASE_*) — login, user_roles, existing dashboard features
 * 2. Self-hosted (REACT_APP_SELF_HOSTED_SUPABASE_*) — class tables in public:
 *    public.class_1, public.prekg, … (one table per class, NOT public.activities)
 */

export const cloudSupabaseConfig = {
  url: process.env.REACT_APP_SUPABASE_URL || '',
  anonKey: process.env.REACT_APP_SUPABASE_ANON_KEY || '',
};

export const selfHostedSupabaseConfig = {
  url: process.env.REACT_APP_SELF_HOSTED_SUPABASE_URL || '',
  anonKey: process.env.REACT_APP_SELF_HOSTED_SUPABASE_ANON_KEY || '',
};

export const isCloudSupabaseConfigured = () =>
  Boolean(cloudSupabaseConfig.url && cloudSupabaseConfig.anonKey);

export const isSelfHostedSupabaseConfigured = () =>
  Boolean(selfHostedSupabaseConfig.url && selfHostedSupabaseConfig.anonKey);

export const selfHostedPublicStorageBase = () => {
  const base = selfHostedSupabaseConfig.url.replace(/\/$/, '');
  return base ? `${base}/storage/v1/object/public` : '';
};

/** e.g. public.class_1 */
export const selfHostedClassTableRef = (tableName) => `public.${tableName}`;
